import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfessionalAccountSideMenuComponent } from './professional-account-side-menu.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [ProfessionalAccountSideMenuComponent],
  imports: [
    CommonModule, SharedModule
  ],
  exports: [ProfessionalAccountSideMenuComponent]
})
export class ProfessionalAccountSideMenuModule { }
